import React from 'react'
import { Col, Button } from 'react-bootstrap'
import { TrashFill } from 'react-bootstrap-icons'
import Icon from '../icon'
import Name from '../name'

const InterestBox = ({
    userInterest = {},
    showDelete,
    onDelete = () => {},
    variant = 'primary'
}) => {
    return (
        <Col
            xs={4}
            md={3}
            lg={4}
            xl={3}
            style={{ paddingTop: '10px', paddingBottom: '10px' }}
        >
            <div
                style={{
                    height: '120px',
                    padding: '10px',
                    backgroundColor: variant === 'primary' ? 'white' : 'rgb( 241, 249, 255)'
                }}
            >
                <div style={{
                    position: 'absolute',
                    top: '8px',
                    right: '16px',
                }}>
                    {showDelete && <Button variant='link'><TrashFill /></Button>}
                </div>
                <div
                    style={{
                        height: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-evenly',
                        borderRadius: '4px',
                        alignItems: 'center'
                    }}
                >
                    <div>
                        <Icon userInterest={userInterest} />
                    </div>
                    <div style={{ fontSize: '0.9em', fontWeight: '700'}} className='text-center'>
                        <Name userInterest={userInterest} />
                    </div>
                    
                </div>
               
            </div>
            
        </Col>
    )
}

export default InterestBox